import React from 'react';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import JobVaultSubmissionContainer from 'buyside/components/container/JobVaultSubmission/JobVaultSubmissionContainer';

const JobVaultSubmissionPageRoot = () => {
  return (
    <ErrorBoundary pageName="new job post submission">
      <JobVaultSubmissionContainer />
    </ErrorBoundary>
  );
};

export default JobVaultSubmissionPageRoot;
